import React, { Fragment, useState, createRef } from 'react'
import { useSpring, animated } from 'react-spring'
import { Icon } from 'semantic-ui-react'
import { sequenceAnimations } from '../animations'
import * as easings from 'd3-ease'
import { respectCondition } from '../modifiers/condition-helpers'
import { getSafeTemplate, cleanText } from '../story-player-utils'
import './sequence-renderer.css'

export const SequenceRenderer = ({story, gameData, path, sequence, gotoSequence, playClickSound, theme, styles}) => {

  const [tween, setTween] = useState({ opacity: 1, translate: 0 })
  const [sequenceProps, setSequenceProps] = useState(false)

  const contentRef = createRef()

  const { opacity, translate } = useSpring({
    config: { duration: 350, easing: easings.easeCubic },
    onRest: () => {
      const {next, actions, conditions} = sequenceProps || {}
      if (tween.immediate) {
        setSequenceProps(null)
        if (contentRef.current) {
          contentRef.current.scrollTop = 0
        }
        setTween({ opacity: 1, translate: 0, immediate: false})
        gotoSequence(next, actions, conditions)
      } else if (tween && tween.opacity === 0) {
        setTween({ opacity: 0, translate: 100, immediate: true })
      }
    },
    ...tween
  })

  const prepareNextSequence = (sequence) => {
    playClickSound()
    setSequenceProps(sequence)
    setTween({ opacity: 0, translate: -100 })
  }

  const getTweenTransform = (t) => {
    const animationStyle = sequenceAnimations.getAnimationStyle(theme.styles.animations ? theme.styles.animations.sequence : null)
    return animationStyle(t)
  }

  const animatedStyles = {
    opacity,
    transform: translate.interpolate(getTweenTransform),
    ...styles.textStyle
  }

  const filterChoice = (choice) => {
    if (choice.showCondition && choice.showCondition.kind) {
      return respectCondition(story, gameData, path, choice.showCondition)
    }
    return true
  }
  
  return (
    <animated.div className="sequence" style={animatedStyles}>
     { sequence && (
        <Fragment>
          <div className="sequence-content">
            <div ref={contentRef} style={ styles.sequence } dangerouslySetInnerHTML={{__html: cleanText(getSafeTemplate(sequence.content))}}/>
          </div>
          <div className="sequence-actions">
            { sequence.choices && sequence.choices.length > 0 ? sequence.choices.filter(c => filterChoice(c)).map((choice, index) => (
              <div key={'choice-' + index}>
                <button style={ styles.button } onClick={() => prepareNextSequence(choice)}><div dangerouslySetInnerHTML={{__html: cleanText(getSafeTemplate(choice.content))}} /></button>
              </div>
            )) : (
              <Fragment>
                { (sequence.final || !sequence.next) ? (
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    {/*<button style={{ ...styles.button, padding: '0.3em 0.35em' }}><Icon name='star' style={{ margin: 0 }} /></button>*/}
                    <button id="bt-replay" style={{ ...styles.button, fontSize: '2em', padding: '0.3em 0.35em' }} onClick={() => prepareNextSequence(sequence)}><Icon name='repeat' style={{ margin: 0 }} /></button>
                    {/*<button style={{ ...styles.button, padding: '0.3em 0.35em' }}><Icon name='share alternate' style={{ margin: 0 }} /></button>*/}
                  </div>
                ) : (
                  <button style={ styles.button } onClick={() => prepareNextSequence(sequence)}><Icon name='caret right' style={{ margin: 0 }} /></button>
                )}
              </Fragment>
            )}
          </div>
        </Fragment>
      )}
    </animated.div>
  )
}